import { CSSProperties } from "react";
import { ReactComponent as Eco } from "../../assets/svg/08-eco.svg";
import { ReactComponent as Map } from "../../assets/svg/09-map.svg";
import {
  TbDashboard,
  TbUserCircle,
  TbCar,
  TbInfoSquareRounded,
  TbCarCrash,
  TbCertificate,
  TbLicense,
  TbSteeringWheel,
  TbMap2,
  TbStars,
  TbSparkles,
  TbRobot,
  TbHelp,
  TbSettings,
  TbLogout,
  TbTrash,
  TbPencil,
  TbCards,
  TbShieldCheck,
  TbEye,
  TbFileStack,
  TbBell,
  TbChevronRight,
  TbSunHigh,
  TbSnowflake,
  TbPlus,
  TbChevronDown,
  TbChevronUp,
  TbCheck,
  TbPhoto,
  TbCertificate2,
  TbX,
  TbSearch,
  TbReload,
  TbBellRinging2,
  TbDots,
  TbMailOpened,
  TbMail,
  TbToggleLeft,
  TbToggleRight,
  TbCopy,
  TbLock,
  TbPaperclip,
  TbFileInfo,
  TbBatteryCharging,
  TbFile,
  TbArrowLeft,
  TbExternalLink,
  TbDownload,
  TbSend,
  TbPlayerStopFilled,
  TbChartHistogram,
  TbReceipt2,
  TbCoinEuro,
  TbAlertTriangle,
} from "react-icons/tb";

type Props = {
  name: string;
  width?: number | string;
  height?: number | string;
  animation?: number | string;
  color?: any;
  style?: CSSProperties;
  onClick?: () => void;
};

// Aligner ces icons par ordres alphabétiques
export const Icon: React.FC<Props> = ({
  name,
  width,
  height,
  color,
  animation,
  style,
  onClick,
}) => {
  switch (name) {
    // Warning glyph. Added for the mileage panel, which needs to distinguish
    // "X km remaining before the over-mileage penalty" from "X km OVER it" —
    // the same number with opposite meanings, so the icon has to carry the
    // difference rather than the copy alone.
    case "alertTriangle":
      return <TbAlertTriangle style={{ width, height, color }} />;
    case "bell":
      return <TbBell style={{ width, height, color }} />;
    case "bell2":
      return <TbBellRinging2 style={{ width, height, color }} />;

    case "copy":
      return (
        <TbCopy style={{ width, height, color, ...style }} onClick={onClick} />
      );
    case "collaborateur":
      return <TbUserCircle style={{ width, height, color }} />;
    case "cards":
      return <TbCards style={{ width, height }} />;
    case "certificate":
      return <TbCertificate style={{ width, height, color }} />;
    case "certificate2":
      return <TbCertificate2 style={{ width, height, color }} />;
    case "chevronRight":
      return <TbChevronRight style={{ width, height }} />;
    case "chevronDown":
      return <TbChevronDown style={{ width, height }} />;
    case "chevronUp":
      return <TbChevronUp style={{ width, height }} />;
    case "check":
      return <TbCheck style={{ width, height, color }} />;
    case "close":
      return <TbX style={{ width, height, color }} />;
    case "send":
      return <TbSend style={{ width, height, color }} />;
    case "stop":
      return <TbPlayerStopFilled style={{ width, height, color }} />;
    case "arrowLeft":
      return <TbArrowLeft style={{ width, height, color }} />;
    case "dashboard":
      return <TbDashboard style={{ width, height, color }} />;
    case "dots":
      return <TbDots style={{ width, height }} />;
    case "download":
      return (
        <TbDownload
          style={{ width, height, color, ...style }}
          onClick={onClick}
        />
      );

    case "eye":
      return <TbEye style={{ width, height, color }} />;
    case "external-link":
      return <TbExternalLink style={{ width, height, color }} />;
    case "battery":
      return <TbBatteryCharging style={{ width, height, color }} />;
    case "file":
      return <TbFile style={{ width, height, color }} />;
    case "fileStack":
      return <TbFileStack style={{ width, height, color }} />;
    case "fileInfo":
      return <TbFileInfo style={{ width, height, color }} />;

    case "help":
      return <TbHelp style={{ width, height, color }} />;

    case "license":
      return <TbLicense style={{ width, height, color }} />;
    case "logout":
      return <TbLogout style={{ width, height, color }} />;

    case "map2":
      return <TbMap2 style={{ width, height, color }} />;
    case "mailOpened":
      return <TbMailOpened style={{ width, height, color }} />;
    case "mail":
      return <TbMail style={{ width, height, color }} />;

    case "notification":
      return <TbInfoSquareRounded style={{ width, height, color }} />;

    case "pencil":
      return (
        <TbPencil
          style={{ width, height, color, ...style }}
          onClick={onClick}
        />
      );
    case "plus":
      return (
        <TbPlus style={{ width, height, color, ...style }} onClick={onClick} />
      );
    case "photo":
      return <TbPhoto style={{ width, height, color }} />;
    case "paperClip":
      return (
        <TbPaperclip
          style={{ width, height, color, ...style }}
          onClick={onClick}
        />
      );

    case "reload":
    return <TbReload style={{ width, height, color, animation }} />;
      case "lock":
        return <TbLock style={{ width, height, color, animation }} />;

    case "sinistre":
      return <TbCarCrash style={{ width, height, color }} />;
    case "stars":
      return <TbStars style={{ width, height, color }} />;
    case "steeringWheel":
      return <TbSteeringWheel style={{ width, height }} />;
    case "search":
      return <TbSearch style={{ width, height, color }} />;
    case "settings":
      return <TbSettings style={{ width, height, color }} />;
    case "shieldCheck":
      return <TbShieldCheck style={{ width, height }} />;
    case "sunHigh":
      return <TbSunHigh style={{ width, height }} />;
    case "snowFlake":
      return <TbSnowflake style={{ width, height }} />;

    case "trash":
      return (
        <TbTrash style={{ width, height, color, ...style }} onClick={onClick} />
      );
    case "toggleRight":
      return (
        <TbToggleRight
          style={{ width, height, color, ...style }}
          onClick={onClick}
        />
      );
    case "toggleLeft":
      return (
        <TbToggleLeft
          style={{ width, height, color, ...style }}
          onClick={onClick}
        />
      );

    case "vehicule":
      return <TbCar style={{ width, height, color }} />;

    case "currency":
      /*
       * Was `<Currency />` (assets/svg/07-currency.svg). That file hardcodes
       * stroke="#000" on its circle and draws the euro sign as an SVG <text>
       * node with no fill, so it ignored `currentColor` entirely and rendered
       * black wherever it was placed -- visibly wrong against the dark
       * sidebar, where every neighbouring icon inherits var(--c-nav-muted).
       * It was also the only non-Tabler glyph in the menu: a filled ring plus
       * a Poppins text node instead of a 24px stroke icon, so it read heavier
       * than the rest even once the colour was right.
       *
       * TbCoinEuro is stroke-based like its neighbours and inherits colour,
       * which fixes both problems at the source rather than by overriding a
       * fill at each call site.
       */
      return <TbCoinEuro style={{ width, height, color }} />;
    case "eco":
      return <Eco width={width} height={height} />;
    case "map":
      return <Map width={width} height={height} />;

    case "sparkles":
      return <TbSparkles style={{ width, height, color }} />;
    case "aiAgent":
      return <TbRobot style={{ width, height, color }} />;

    // Analyse & optimisation
    case "tax":
      return <TbReceipt2 style={{ width, height, color }} />;
    case "analytics":
      return <TbChartHistogram style={{ width, height, color }} />;

    default:
      return null;
  }
};
